module.exports = __webpack_public_path__ + "static/jambo-e7930217ceade97b400ef10ae0f6f1de.jpg";